import Swiper from 'swiper';

const AUTOPLAY_DELAY = 8000;

export function initTabSlider() {
    document.querySelectorAll('.tabSlider').forEach(el => {
        const tiles       = [...el.querySelectorAll('.tabSlider__tile')];
        const slides      = [...el.querySelectorAll('.tabSlider__slide')];
        const currentEls  = [...el.querySelectorAll('.tabSlider__pagination-current')];
        const totalEls    = [...el.querySelectorAll('.tabSlider__pagination-total')];
        const progressEls = [...el.querySelectorAll('.tabSlider__pagination-progress')];

        if (!tiles.length || !slides.length) return;

        let current = 0;
        let timer   = null;
        let tilesSwiper = null;

        totalEls.forEach(el => {
            el.textContent = String(slides.length).padStart(2, '0');
        });

        function resetProgress() {
            progressEls.forEach(p => {
                p.style.animation = 'none';
                p.offsetHeight; // eslint-disable-line no-unused-expressions
                p.style.animation = '';
            });
        }

        function activate(index) {
            tiles.forEach((t, i)  => t.classList.toggle('is-active', i === index));
            slides.forEach((s, i) => s.classList.toggle('is-active', i === index));

            currentEls.forEach(el => {
                el.textContent = String(index + 1).padStart(2, '0');
            });

            // Mobil sind die Kacheln ein Swiper: die aktive Kachel muss mitwandern,
            // sonst wechselt unten der Text waehrend oben dieselbe Kachel stehen bleibt.
            if (tilesSwiper && tilesSwiper.enabled) {
                tilesSwiper.slideTo(index);
            }

            resetProgress();
            current = index;
        }

        function startAutoplay() {
            clearInterval(timer);
            timer = setInterval(() => {
                activate((current + 1) % tiles.length);
            }, AUTOPLAY_DELAY);
        }

        tiles.forEach((tile, i) => {
            tile.addEventListener('click', () => {
                activate(i);
                startAutoplay();
            });
        });

        // Mobile Swiper für die Tiles (ab md per CSS deaktiviert)
        const tilesContainer = el.querySelector('.tabSlider__tiles');
        if (tilesContainer) {
            tilesSwiper = new Swiper(tilesContainer, {
                slidesPerView: 'auto',
                spaceBetween: 0,
                breakpoints: {
                    768: {
                        enabled: false,
                    }
                }
            });
        }

        const textEls = [...el.querySelectorAll('.tabSlider__slide-text')];
        textEls.forEach(textEl => {
            textEl.addEventListener('mouseenter', () => { clearInterval(timer); el.classList.add('is-paused'); });
            textEl.addEventListener('mouseleave', () => { el.classList.remove('is-paused'); resetProgress(); startAutoplay(); });
        });

        activate(0);
        startAutoplay();
    });
}
